import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'LinkService'
const host = servicesConfig.Links
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const LinkService = {
  list: (locationId: string) => 
    request().get(`/?locationId=${locationId}`).then(responseBody),
    
  delete: (linkId: string) =>
    request().delete(`/${linkId}`).then(responseBody)
}

export default LinkService